/**
 * Company contact details — the single source of truth.
 *
 * These were previously scattered: the callback band and thank-you screen each
 * carried their own hardcoded number, and none of them agreed with the Figma.
 * Everything now reads from here, so correcting the real number is a one-line
 * change rather than a hunt.
 *
 * Real values as of 2026-08-31, taken from the client's privacy policy
 * ("Privacy Policy copy Save on Broadband.docx"), which replaced the Figma's
 * placeholders. Note the document names two entities: SaveonBroadband is the
 * data controller, Neatley Ltd is the postal correspondent, and the support
 * mailbox is on the neatley.co.uk domain. That is the client's own wording,
 * not a transcription slip. The client asked (2026-09-02) for the postal
 * address to name both, as "Save on Broadband from Neatley LTD".
 *
 * The number is written in standard UK grouping (0330 053 9114) rather than
 * the document's own "03300 539 114" — same number, dialled identically.
 *
 * `hours` is when the phones are staffed, confirmed by the client. It is NOT a
 * gate on the journey: leads are captured and queued around the clock.
 */
export const CONTACT_DETAILS = {
  phone: '0330 053 9114',
  phoneHref: '03300539114',
  email: 'support@neatley.co.uk',
  privacyEmail: 'support@neatley.co.uk',
  hours: 'Mon-Fri 9am-6pm',
  address: 'Save on Broadband from Neatley LTD, 12 Church Row Chambers, Preston, PR4 5PN',
  /** Quoted in the thank-you copy as the number the call will come from. */
  outboundPrefix: '0330',
  /** Named in the privacy policy's data-rights section. */
  dataProtectionOfficer: 'Phil Morgan',
};
